import { render, staticRenderFns } from "./spotMarket.vue?vue&type=template&id=4d721616&"
import script from "./spotMarket.vue?vue&type=script&lang=js&"
export * from "./spotMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports